/**
 * @param {Array<string>} names array of names to join
 * @param {Object} options object with options
 * @param {String} options.prefix prefix to append
 * @param {String} options.divider divider to use when join names
 */
export function buildEventName(names = [], { prefix = '', divider = '' } = {}) {
  return [prefix, ...names].filter(Boolean).join(divider)
}

export function buildCategoryName(names, prefix) {
  return buildEventName(names, { prefix, divider: ' / ' })
}

export function buildTagNames(names, prefix) {
  return names.map(name => buildCategoryName([prefix, name]))
}
